<template>
  <Section :title="jobs.title">
    <div class="experience-item" v-for="(j, i) in jobs.jobs" :key="i">
      <div>
        <div class="role">{{ j.position }}</div>
        <div class="company">{{ j.company }} · {{ j.city ? (j.city + (j.country ? ', ' + j.country : '')) : (j.country || '') }}</div>
      </div>
      <div class="date">{{ j.date }}</div>
    </div>
  </Section>
</template>

<script>
import Section from "./Section";

export default {
  name: "Experience",
  components: { Section },
  props: {
    jobs: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.experience-item {
  margin-bottom: 5mm;
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3mm;
  padding-bottom: 4mm;
  border-bottom: 0.5px solid #e0e0e0;
}

.experience-item:last-child {
  border-bottom: none;
  margin-bottom: 0;
}

.role {
  font-size: 9pt;
  font-weight: 700;
  line-height: 1.3;
  color: #000;
}

.company {
  font-size: 8pt;
  color: #666;
  margin-top: 1mm;
  font-weight: 400;
}

.date {
  font-size: 8pt;
  color: #000;
  text-align: right;
  font-weight: 400;
}

@media screen and (max-width: 202mm) {
  .experience-item {
    grid-template-columns: 1fr;
    gap: 1mm;
  }
  
  .date {
    text-align: left;
  }
}
</style>
